module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/window/window.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/window/window.png
// module id = 503
// module chunks = 0